var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1626 7.17163C6.1626 6.20513 6.9461 5.42163 7.9126 5.42163H28.9029C29.8694 5.42163 30.6529 6.20513 30.6529 7.17163C30.6529 8.13813 29.8694 8.92163 28.9029 8.92163H9.6626V47.4216H28.9126C29.8791 47.4216 30.6626 48.2051 30.6626 49.1716C30.6626 50.1381 29.8791 50.9216 28.9126 50.9216H7.9126C6.9461 50.9216 6.1626 50.1381 6.1626 49.1716V7.17163Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1752 16.4342C38.8586 15.7508 39.9666 15.7508 40.65 16.4342L51.15 26.9342C51.8335 27.6176 51.8335 28.7257 51.15 29.4091L40.65 39.9091C39.9666 40.5925 38.8586 40.5925 38.1752 39.9091C37.4917 39.2257 37.4917 38.1176 38.1752 37.4342L47.4377 28.1716L38.1752 18.9091C37.4917 18.2257 37.4917 17.1176 38.1752 16.4342Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8293 28.1619C17.8293 27.1954 18.6128 26.4119 19.5793 26.4119H49.9126C50.8791 26.4119 51.6626 27.1954 51.6626 28.1619C51.6626 29.1284 50.8791 29.9119 49.9126 29.9119H19.5793C18.6128 29.9119 17.8293 29.1284 17.8293 28.1619Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.264a9df8.svg";
export { ForwardRef as ReactComponent };